import Icon from "@components/ui/icon";
import { toast } from "react-toastify";

interface IProps {
  msg?: string;
}

export const sendMediaLibUploadedToast = ({
  msg = "Uploaded",
}: IProps = {}) => {
  return toast.success(msg, {
    autoClose: 5000,
    icon: (
      <Icon
        icon="ri-checkbox-circle-fill"
        className="tw-text-[16px]/none tw-text-white"
      />
    ),
    className: "images-panel-clickable",
  });
};
